import Index from '../components/UseTerms/Index';

let routes = {
    path: '/useTerms',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/useTerms',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/useTerms.js